module.exports = __webpack_public_path__ + "static/logo-blue-ba9f24f94dff7bbe39e277503b4e3d10.svg";